import { useMemo } from "react";
import { selectOneTimePurchaseData } from "store/selectors/oneTimePurchaseSelectors";
import { useSessionUser } from "hooks/useSession";
import { useProjectQuota } from "hooks/useProjectQuota";

export const useOneTimePurchase = () => {
  const { session } = useSessionUser();
  // Unlicensed projects count against the per-workspace unlicensed cap, not the
  // monthly subscription capacity (which is 0 for one-time-purchase users).
  const { unlicensedUnderCap, isLoading: isQuotaLoading } = useProjectQuota();

  return useMemo(() => {
    const data = selectOneTimePurchaseData(session, unlicensedUnderCap);
    // unlicensedUnderCap defaults to true until the quota loads; report loading
    // so create-project guards wait instead of acting on the default.
    return { ...data, isLoading: data.isLoading || isQuotaLoading };
  }, [session, unlicensedUnderCap, isQuotaLoading]);
};
